import { appThemeColors } from "styles/appTheme";
import { appTypography } from "styles/appThemeFonts";

export const clockTextSx = {
  ...appTypography.clock,
  whiteSpace: "nowrap",
  color: appThemeColors.text.muted,
};
